<template>
  <modal id="editAccountPropDialog"
         :show="showModal"
         modal-classes="modal-dialog-centered modal-lg"
         showClose @close.capture="resetForm()">
    <template slot="header">
      <h4 class="modal-title">
        {{ $t('accountProps.update.titleText') }}
      </h4>
    </template>
    <template>
      <div class="text-center text-muted mb-4">
        <small>{{ $t('accountProps.update.helpText') }}</small>
      </div>
      <base-alert v-if="alert" dismissible :dismiss-callback="() => alert=false" type="danger">
        <!-- TODO: add error translation -->
        {{ getActionErrorDetails }}
      </base-alert>
      <form role="form" @submit.prevent="validate()">
        <div class="row">
          <label class="col-sm-4 col-form-label">{{ $t('generic.type') }}</label>
          <div class="col-sm-8">
            <base-input
              :error="getError('type')">
              <el-select
                name="type"
                data-vv-as="'type'"
                class="select-primary"
                v-validate="modelValidations.required"
                v-model="formDetails.type">
                <el-option
                  v-for="option in availableAccountPropTypes"
                  class="select-primary"
                  :value="option"
                  :label="$t('accountProps.knownPropTypes.'+option)"
                  :key="option">
                </el-option>
              </el-select>
            </base-input>
          </div>
        </div>
        <div class="row">
          <label class="col-sm-4 col-form-label">{{ $t('accountProps.details.value') }}</label>
          <div class="col-sm-8">
            <base-input
              type="string"
              name="value"
              v-validate="modelValidations.required"
              :error="getError('value')"
              v-model="formDetails.value"/>
          </div>
        </div>
        <div class="text-center">
          <base-button
            type="info"
            class="my-4"
            @click="validate()"
            :loading="updating"
          >{{ $t('accountProps.update.actionBtnLabel') }}
          </base-button>
        </div>
      </form>
    </template>
  </modal>
</template>


<script>
import {BaseAlert, Modal} from 'src/components';
import {Option, Select} from 'element-ui';
import {mapActions, mapState} from "vuex";

export default {
  name: 'editAccountPropDialog',
  components: {
    [Option.name]: Option,
    [Select.name]: Select,
    Modal,
    BaseAlert,
  },
  props: {
    showModal: {
      type: Boolean,
      required: true,
    },
    currentDetails: {
      type: Object,
      required: false,
    },
  },
  data() {
    return {
      alert: false,
      formDetails: {
        type: this.currentDetails ? this.currentDetails.type : '',
        value: this.currentDetails ? this.currentDetails.value : '',
      },
      modelValidations: {
        required: {
          required: true
        },
        number: {
          numeric: true
        },
      }
    }
  },
  computed: {
    ...mapState({
      updating: state => state.account_props.updating,
      error: state => state.account_props.error,
      data: state => state.account_props.data,
      availableAccountPropTypes: state => state.account_props.availableTypes,
    }),
    getActionErrorDetails() {
      return this.error ? this.error.bodyText : null;
    },
  },
  methods: {
    ...mapActions(['UpdateAccountProps', 'LoadAccountProps']),
    getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validate() {
      this.$validator.validateAll().then(isValid => {
        if (isValid) {
          this.update()
        }
      });
    },
    update: function () {
      let payload = {
        id: this.currentDetails.id,
        accountId: this.currentDetails.account_id,
        data: {
          type: this.formDetails.type,
          value: this.formDetails.value,
        }
      }
      this.UpdateAccountProps(payload).then(() => {
        if (this.error != null) {
          this.alert = true
          // got error, don't reset form
        } else {
          this.$notify({
            type: 'success',
            message: this.$t('accountProps.update.successNotification', payload.data),
            icon: 'tim-icons icon-alert-circle-exc'
          })
          this.LoadAccountProps(this.currentDetails.account_id)
          this.resetForm()
        }
      });
    },
    resetForm: function () {
      this.alert = false;
      // resetting form
      this.formDetails = {
        type: '',
        value: '',
      }
      // reset validation errors
      this.$validator.reset()
      this.$emit('close');
    },
  },
  watch: {
    currentDetails() {
      this.formDetails = {
        type: this.currentDetails ? this.currentDetails.type : '',
        value: this.currentDetails ? this.currentDetails.value : '',
      }
    }
  },
}
</script>
